import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';

import pluralize from 'rebook/apps/utils/text/pluralize';
import { Book } from 'rebook/apps/books/models';
import BookCitation from 'rebook/apps/books/components/BookCitation';

import styles from './style.scss';


const BookDetailCitationList = ({ citations, book }) => {
  const theBook = new Book(book);
  if (!citations || citations.length === 0) {
    return null;
  }

  const isAudioBook = get(book, 'type', '') === 'audio';
  const title = book.citations_count > 3
    ? (
      <Link to={theBook.getCitationsLink()}>
        <div className={styles.reviewTitle}>
          <div>
            <div className={styles.reviewTitleHeader}>
              <h2>
                Цитаты из {isAudioBook ? 'аудиокниги' : 'книги'}{' '}
                <span className={styles.titleBookName}>«{book.name}»</span>
              </h2>
            </div>
          </div>
          <div className={classNames(styles.link, 'link')}>
            <span className={styles.linkText}>
              <span className={styles.linkTextPrefix}>
                Всего&nbsp;
              </span>
              {book.citations_count}&nbsp;
            </span>
            <span className={classNames('arrowRight', styles.arrow)} />
          </div>
        </div>
      </Link>
    ) : (
      <div className={styles.reviewTitleHeader}>
        <h2>
          Цитаты из {isAudioBook ? 'аудиокниги' : 'книги'}{' '}
          <span className={styles.titleBookName}>«{book.name}»</span>
        </h2>
      </div>
    );

  return (
    <div className={classNames(styles.citationContainer, 'billetContainerNoOverflow')}>
      <div className={styles.title}>
        {title}
      </div>
      <div>
        <ol>
          {citations.map((item) => (
            <li className={styles.item} key={item.id}>
              <BookCitation citation={item} textTitle="Моя цитата" />
            </li>
          ))}
        </ol>
      </div>
      {book.citations_count > 3 &&
        <div className={styles.others}>
          <Link to={theBook.getCitationsLink()} className={styles.othersLink}>
            Еще {book.citations_count - 3}&nbsp;{pluralize(book.citations_count - 3, 'цитата', 'цитаты', 'цитат')}
          </Link>
        </div>
      }
    </div>
  );
};

BookDetailCitationList.propTypes = {
  citations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
    })
  ),
};

export default BookDetailCitationList;
